/**
 * Shared color constants for board road sections
 *
 * Centralizes all colors used across Top, Bottom, Left, Right road sections
 * to ensure consistency and easier maintenance.
 */

export const ROAD_COLORS = {
  // Player colors - Blue (Top section)
  blue: {
    finalStretch: '#5176EF',
    center: '#002899',
    solid: '#002899'
  },

  // Player colors - Green (Bottom section)
  green: {
    light: '#51AB4B',
    dark: '#087000',
    finalStretch: '#087000'
  },

  // Player colors - Yellow (Left section)
  yellow: {
    dark: '#A08500',
    bright: '#FFE721'
  },

  // Player colors - Red (Right section)
  red: {
    bright: '#F20000',
    dark: '#990000'
  },

  // Shared gradient colors
  gradients: {
    greenDark: {
      start: '#317A0A',
      end: '#469B15'
    },
    greenLight: {
      start: '#96C23B',
      end: '#BBD849'
    },
    brownGround: {
      start: '#72381B',
      end: '#754C24'
    },
    grassOverlay: {
      start: '#4B9E36',
      end: '#8CC63F'
    },
    yellowStretch: {
      start: '#FFCE00',
      middle: '#FFF810',
      end: '#FFCE00'
    }
  },

  // Common colors
  white: 'white',
  black: 'black',
  shadowBlack: '#303030',
  placeholderGray: '#C4C4C4',
  lightGray: '#EFEFEF'
} as const;
